import React from 'react';
import PropTypes from 'prop-types';
import pluralize from 'pluralize';
import moment from 'moment';

export function format(input, short = false, isMonth = false) {
  if (Number.isNaN(input)) {
    return null;
  }

  const duration = moment.duration(input, isMonth ? 'months' : 'days');
  const years = duration.years();
  const months = duration.months();
  const days = duration.days();

  const display = [];
  const longDisplay = [];
  if (years) {
    const yearUnit = pluralize('year', years);
    display.push(`${years}${short ? 'Y' : ` ${yearUnit}`}`);
    longDisplay.push(`${years} ${yearUnit}`);
  }
  if (months) {
    const monthUnit = pluralize('month', months);
    display.push(`${months}${short ? 'M' : ` ${monthUnit}`}`);
    longDisplay.push(`${months} ${monthUnit}`);
  }
  if (days) {
    const dayUnit = pluralize('day', days);
    display.push(`${days}${short ? 'D' : ` ${dayUnit}`}`);
    longDisplay.push(`${days} ${dayUnit}`);
  }
  if (display.length === 0) {
    if (short) {
      display.push('0D');
    } else {
      display.push('0 days');
    }
    longDisplay.push('0 days');
  }
  return {
    display: display.join(' '),
    longDisplay: longDisplay.join(' '),
  };
}

function AgeDisplay(props) {
  const { value, short, isMonth } = props;
  const v = format(value, short, isMonth);
  return (
    <span className="age-display">{v.display}</span>
  );
}

AgeDisplay.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.number,
  ]),
  short: PropTypes.bool,
  isMonth: PropTypes.bool,
};
AgeDisplay.defaultProps = {
  value: null,
  short: false,
  isMonth: false,
};
export default AgeDisplay;
